module.exports = __webpack_public_path__ + "img/product_57.05e010a.webp";